import React, { useState } from "react";
import useSWR from "swr";
import BankInclusionApprovalModalContent from "./BankInclusionApprovalModalContent";
import { fetcher } from "../../../utilities/_fetcher";

const BankInclusionApprovalModal = ({
  request,
  onClose,
  onReject,
  onSendBack,
  onApprove,
  isSessionMode = false,
  mutateBankInclusionList,
}) => {
  const [detailedRequest, setDetailedRequest] = useState(null);

  const detailsApiUrl = request?.bank_info_id
    ? `${process.env.REACT_APP_API_URL}/api/bank-inclusion/v1/qc-details?bank_info_id=${request.bank_info_id}`
    : null;

  const { data: detailsResponse, error: detailsError } = useSWR(
    detailsApiUrl,
    fetcher,
    {
      onSuccess: (data) => {
        if (data && Object.keys(data).length > 0) {
          const requestKey = Object.keys(data)[0];
          const apiData = data[requestKey];

          const transformedData = {
            bank_info_id: request.bank_info_id,
            request_details: {
              request_id: requestKey,
              bank_name: apiData.request_details?.bank_name,
              branch_name: apiData.request_details?.bank_branch_name,
              bank_routing_number: apiData.request_details?.bank_routing_number,
              account_holder_name: apiData.request_details?.account_holder_name,
              account_number: apiData.request_details?.account_number,
              account_type: request.request_details?.account_type,
              micr_line_number: apiData.request_details?.micr_line_number,
              request_date: request.request_details?.request_date,
              bank_inclusion_form_image:
                apiData.images?.bank_inclusion_form_image || null,
              check_book_image: apiData.images?.check_book_image || null,
            },
            merchant_details: {
              merchant_wallet: apiData.merchant_details?.wallet_number,
              merchant_name: apiData.merchant_details?.merchant_name,
              owner_name: apiData.merchant_details?.merchant_full_name,
              owner_phone: "N/A",
              address: apiData.merchant_details?.shop_address,
              reg_date: apiData.merchant_details?.registration_date,
              reg_tenure: apiData.merchant_details?.registration_tenure,
              merchant_type: apiData.merchant_details?.product_type,
              bmcc_number: apiData.merchant_details?.bmcc_code,
              bmcc_type: apiData.merchant_details?.bmcc_category,
              owner_image: apiData.images?.shop_owner_image || null,
              outlet_image: apiData.images?.outlet_image || null,
              requested_by: apiData.merchant_details?.requested_by || {},
            },
          };

          setDetailedRequest(transformedData);
        }
      },
      revalidateOnFocus: false,
    },
  );

  const loading = !detailsResponse && !detailsError;
  const requestData = detailedRequest || request;

  const handleModalClose = () => {
    onClose();
  };

  const handleApprove = (requestData) => {
    if (mutateBankInclusionList) {
      mutateBankInclusionList();
    }
    if (onApprove) {
      onApprove(requestData);
    } else {
      handleModalClose();
    }
  };

  const handleReject = () => {
    if (mutateBankInclusionList) {
      mutateBankInclusionList();
    }
    if (onReject) {
      onReject();
    } else {
      handleModalClose();
    }
  };

  const handleSendBack = () => {
    if (mutateBankInclusionList) {
      mutateBankInclusionList();
    }
    if (onSendBack) {
      onSendBack();
    } else {
      handleModalClose();
    }
  };

  return (
    <BankInclusionApprovalModalContent
      requestData={requestData}
      loading={loading}
      error={!!detailsError}
      onClose={handleModalClose}
      onReject={handleReject}
      onApprove={handleApprove}
      onSendBack={handleSendBack}
      isSessionMode={isSessionMode}
    />
  );
};

export default BankInclusionApprovalModal;
